// Printable transcript of a Nudge Console chat (Create Campaign, AI Nudge Creation).

const escapeHtml = s => String(s == null ? '' : s)
  .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')

const chipLabel = item => escapeHtml(typeof item === 'string' ? item : item.label)

// Renders one SystemMessage content block for the printable export — needs to stay in
// sync with the block types SystemMessage.vue actually supports (see that file for the
// live, interactive versions of these).
function exportBlock (el) {
  const pill = text => `<span style="display:inline-block;border:1px solid #ccc;border-radius:20px;padding:2px 10px;margin:2px;font-size:12px;">${text}</span>`

  if (el.type === 'text') return `<p style="margin:0 0 6px;white-space:pre-wrap;">${escapeHtml(el.value)}</p>`
  if (el.type === 'chips' || el.type === 'multi_chips' || el.type === 'tags') {
    return `<div style="margin:4px 0;">${(el.items || []).map(item => pill(chipLabel(item))).join(' ')}</div>`
  }
  if (el.type === 'buttons') {
    return `<div style="margin:4px 0;">${(el.items || []).map(item => pill(escapeHtml(item.label))).join(' ')}</div>`
  }
  if (el.type === 'cards') {
    return (el.items || []).map(card => `
      <div style="border:1px solid #ddd;border-radius:8px;padding:8px 12px;margin:4px 0;">
        <strong>${escapeHtml(card.title)}</strong>
        ${card.subtitle ? `<div style="font-size:12px;color:#666;">${escapeHtml(card.subtitle)}</div>` : ''}
      </div>`).join('')
  }
  if (el.type === 'config') {
    return `<div style="margin:4px 0;">${(el.items || []).map(row => `
      <div style="display:flex;justify-content:space-between;gap:12px;font-size:12.5px;padding:2px 0;">
        <span style="color:#888;">${escapeHtml(row.label)}</span><span>${escapeHtml(row.value)}</span>
      </div>`).join('')}</div>`
  }
  if (el.type === 'content-editor') {
    // Exports the AI's originally generated draft, not any live edits made in the
    // textarea — that edited text lives only in SystemMessage.vue's own component
    // state and isn't lifted up to this level.
    return (el.languages || []).map(lang => `
      <div style="margin:4px 0;">
        <div style="font-size:11px;font-weight:600;color:#888;">${escapeHtml(lang)}</div>
        <p style="margin:2px 0;white-space:pre-wrap;">${escapeHtml((el.initial || {})[lang])}</p>
      </div>`).join('')
  }
  return ''
}

export function exportTranscript (messages, title) {
  const rows = messages.map(m => {
    const isUser = m.role === 'user'
    const time = m.timestamp ? new Date(m.timestamp).toLocaleTimeString() : ''
    const bubbleStyle = isUser
      ? 'margin-left:auto;background:#e6f7f7;border-radius:14px 14px 2px 14px;'
      : 'margin-right:auto;background:#f5f5f5;border-radius:14px 14px 14px 2px;'
    const label = isUser ? 'You' : 'NiVi AI'
    let body = ''
    if (m.text) {
      body = `<p style="margin:0;white-space:pre-wrap;">${escapeHtml(m.text)}</p>`
    } else if (m.content) {
      body = m.content.map(exportBlock).join('')
    }
    return `
      <div style="display:flex;flex-direction:column;margin-bottom:16px;">
        <div style="font-size:11px;color:#888;margin-bottom:4px;${isUser ? 'text-align:right;' : ''}">${label} · ${time}</div>
        <div style="max-width:75%;padding:10px 14px;${bubbleStyle}">${body}</div>
      </div>`
  }).join('')

  const win = window.open('', '_blank')
  win.document.write(`
    <!DOCTYPE html><html><head><title>${escapeHtml(title)} Export</title>
    <style>body{font-family:sans-serif;font-size:13px;padding:24px;max-width:700px;margin:0 auto;color:#222;}</style>
    </head><body><h3 style="margin-bottom:20px;">${escapeHtml(title)} Transcript</h3>${rows}</body></html>`)
  win.document.close()
  win.focus()
  win.print()
}



// WEBPACK FOOTER //
// ./src/components/nudge-console/chatExport.js